const features = [
  {
    icon: 'ri-shield-check-line',
    title: '内容精选把关',
    desc: '探花系列编辑团队每日人工甄选，确保每一条探花大神作品与探花精选内容都经过严格审核。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '实时更新同步',
    desc: '探花一区与探花91社区内容实时同步，第一时间呈现最新探花探花资源与热门话题。',
  },
  {
    icon: 'ri-stack-line',
    title: '完整合集整理',
    desc: '系统化整理探花大神合集与探花精品资源，按创作者、主题、系列多维度构建内容索引。',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: '社区口碑推荐',
    desc: '基于探花迷真实评价与浏览数据，打造探花精选口碑推荐体系，热门内容一目了然。',
  },
  {
    icon: 'ri-device-line',
    title: '多端畅享体验',
    desc: '支持桌面端与移动端流畅访问，无论何时何地都能畅享探花大神专区与探花一区精选内容。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-18 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-4">
            <i className="ri-sparkling-line"></i>
            平台优势
          </div>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
            为什么选择探花系列
          </h2>
          <p className="mt-2 text-sm text-foreground-500 max-w-lg mx-auto">
            五大核心优势，打造探花迷最信赖的内容聚合平台
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {features.map((feat, i) => (
            <div
              key={i}
              className="group p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/20 transition-all duration-300 text-center cursor-default"
            >
              <div className="w-12 h-12 mx-auto mb-4 rounded-xl bg-primary-100/80 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
                <i className={`${feat.icon} text-xl text-primary-600`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-800 mb-2">{feat.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}